// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"antd-pro-pages-editor-koni-components-editor-context-menu-index-contextMenu","item":"antd-pro-pages-editor-koni-components-editor-context-menu-index-item"};